// V4.1.3: Formatting utility fonksiyonları

// Email formatı oluştur (Firebase'deki mevcut format ile uyumlu)
export const createEmailFromName = (ad) => {
  ad = ad.replace(/İ/g, 'i');
  return ad
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/\s+/g, '.')
    + '@buharavakfi-samsun.com';
};

// Türk para formatı - 1.600,00 TL
export const formatTurkishCurrency = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return '0,00';
  
  const parts = num.toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  
  return `${integerPart},${decimalPart}`;
};

